export default __webpack_public_path__ + "static/media/640_business01-nl-web.bdc35ade.png";